import { generateTestId } from "@client-shared";

export const setInvoiceDetailDrawerTestId = (identifier: string): string =>
  generateTestId("InvoiceDetailDrawer", identifier);
